import { GATrackEvent } from 'utils/googleAnalytics'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'
import { REFERRER_KEY } from 'utils/hooks/useRouterHistory'

type TInspirationsPageTrackerParams = {
  activity_type: string
  event_trigger?: string
  with_notification?: boolean
  content_page?: number
  content_type?: string | string[]
  content_id?: string | string[]
  content_location?: number
}

export const useGATrackEvent = () => {
  const APP_LOGIN_KEY = 'app-login'
  const [userData] = useLocalStorage(APP_LOGIN_KEY, false)
  const [, , , getReferrerValue] = useLocalStorage(REFERRER_KEY, null)
  const referrer = getReferrerValue()
  const EVENT_TRIGGER_MAPPING = {
    '/home': 'HOMEPAGE',
    '/learning-group': 'CLASS_SETTINGS',
    '/akun': 'ACCOUNT',
  }

  const getEventTrigger = () => EVENT_TRIGGER_MAPPING?.[referrer] ?? ''

  const GATrackEventInspirationsPage = (
    params: TInspirationsPageTrackerParams
  ) => {
    GATrackEvent({
      eventName: 'GURU_CORE_APP',
      eventParams: {
        event_trigger: getEventTrigger(),
        referrer_screen_name: getEventTrigger(),
        screen_name: 'INSPIRATION_PAGE',
        is_login: !!userData?.user,
        page_location: window.location.origin,
        page_element: null,
        user_id: userData?.user?.id ?? null,
        ...params,
      },
    })
  }

  return { GATrackEventInspirationsPage }
}
